"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _mealConfigApi = require("@/api/mealConfigApi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GeneralConfig',
  data: function data() {
    return {
      form: {},
      brandList: [],
      loading: false,
      submitting: false,
      originalBrandList: []
    };
  },
  created: function created() {
    this.initBrandList(); // 先初始化一个空的品牌列表
    this.fetchBrandConfigList();
  },
  methods: {
    // 初始化品牌列表
    initBrandList: function initBrandList() {
      this.brandList = [{
        brand: '',
        supplierId: '',
        flowerId: '',
        joyShareId: '',
        useType: 'flower'
      }];
      this.originalBrandList = JSON.parse(JSON.stringify(this.brandList));
    },
    fetchBrandConfigList: function fetchBrandConfigList() {
      var _this = this;
      this.loading = true;
      (0, _mealConfigApi.getBrandConfigList)().then(function (res) {
        try {
          // 由于前端过滤器，res直接就是data数据
          if (res && Array.isArray(res) && res.length > 0) {
            // 确保每个对象都有所需的字段
            var validBrandList = res.map(function (item) {
              return {
                id: item.id || null,
                brand: item.brand || '',
                supplierId: item.supplierId || '',
                flowerId: item.flowerId || '',
                joyShareId: item.joyShareId || '',
                useType: item.useType || 'flower'
              };
            });
            _this.brandList = validBrandList;
            _this.originalBrandList = JSON.parse(JSON.stringify(validBrandList));
          } else {
            // 处理空数据情况
            _this.initBrandList();
          }
        } catch (error) {
          console.error('处理品牌配置列表数据出错:', error);
          _this.initBrandList();
        }
      }).catch(function (err) {
        console.error('获取品牌配置列表失败:', err);
        _this.initBrandList();
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleDelete: function handleDelete(index, row) {
      var _this2 = this;
      this.$confirm('确认删除该品牌配置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        if (row.id) {
          // 如果有ID，调用删除API
          (0, _mealConfigApi.deleteBrandConfig)(row.id).then(function () {
            _this2.brandList.splice(index, 1);
            // 如果删除后没有品牌了，添加一个空行
            if (_this2.brandList.length === 0) {
              _this2.addBrand();
            }
            _this2.$message({
              type: 'success',
              message: '删除成功!'
            });
            // 删除成功后刷新数据
            _this2.fetchBrandConfigList();
          }).catch(function (err) {
            console.error('删除品牌配置失败:', err);
            _this2.$message.error('删除失败：' + (err && err.message ? err.message : '未知错误'));
          });
        } else {
          // 如果没有ID，直接从列表中删除
          _this2.brandList.splice(index, 1);
          // 如果删除后没有品牌了，添加一个空行
          if (_this2.brandList.length === 0) {
            _this2.addBrand();
          }
          _this2.$message({
            type: 'success',
            message: '删除成功!'
          });
        }
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addBrand: function addBrand() {
      this.brandList.push({
        brand: '',
        supplierId: '',
        flowerId: '',
        joyShareId: '',
        useType: 'flower'
      });
    },
    submitForm: function submitForm() {
      var _this3 = this;
      // 验证数据
      var invalidItem = this.brandList.find(function (item) {
        return !item.brand || !item.useType;
      });
      if (invalidItem) {
        this.$message.error('品牌名称和使用渠道不能为空');
        return;
      }
      this.submitting = true;
      var requestData = {
        brandConfigList: this.brandList.map(function (item) {
          return {
            id: item.id || null,
            brand: item.brand,
            supplierId: item.supplierId || '',
            flowerId: item.flowerId || '',
            joyShareId: item.joyShareId || '',
            useType: item.useType
          };
        })
      };
      (0, _mealConfigApi.batchSaveBrandConfig)(requestData).then(function () {
        _this3.$message({
          message: '保存成功',
          type: 'success'
        });
        _this3.fetchBrandConfigList(); // 重新加载数据
      }).catch(function (err) {
        console.error('保存品牌配置列表失败:', err);
        _this3.$message.error('保存失败：' + (err && err.message ? err.message : '未知错误'));
      }).finally(function () {
        _this3.submitting = false;
      });
    },
    resetForm: function resetForm() {
      this.brandList = JSON.parse(JSON.stringify(this.originalBrandList));
      if (this.brandList.length === 0) {
        this.initBrandList();
      }
    }
  }
};